module.exports = __webpack_public_path__ + "static/media/i_pad_pro.15e60e5e.jpg";